import { plainToClass } from 'class-transformer'
import Response from '@/utils/response'
import mPageLoading from '@/mixins/page-loading'
import mPagination from '@/mixins/pagination'
import mNotificationActions from '@/mixins/notification-actions'
import Notification from '@/models/notification'
import Pagination from '@/components/Pagination'

const DEFAULT_PER_PAGE = 20

export default {
  components: {
    Pagination,
  },
  mixins: [
    mPageLoading,
    mPagination,
    mNotificationActions,
  ],
  beforeRouteUpdate (to, from, next) {
    this.fetchData(to.params.status)
    next()
  },
  props: {
    repository: Object,
    status: String
  },
  data: () => ({
    loading: false,
    notifications: [],
    defaultPerPage: DEFAULT_PER_PAGE,
  }),
  computed: {
    tabItems () {
      return [
        { text: this.$t('pages.notifications.index.tab.unread'), value: 'unread' },
        { text: this.$t('pages.notifications.index.tab.read'),   value: 'read'   },
      ]
    },
  },
  mounted () {
    this.fetchData(this.status)
  },
  methods: {
    fetchData (status) {
      if (status === 'read')
        this.fetchReadData()
      else
        this.fetchUnreadData()
    },
    async fetchUnreadData() {
      if (this.loading) {
        return
      }
      this.loading = true

      try {
        const response = new Response(await this.repository.get({
          params: this.pageParams()
        }))
        this.notifications = plainToClass(Notification, response.result)
        this.pagination.totalCount = response.pageInfo.total_count
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    async fetchReadData () {
      if (this.loading) {
        return
      }
      this.loading = true

      try {
        const response = new Response(await this.repository.get({
          params: this.pageParams().deepMerge({
            status: 'read'
          })
        }))
        this.notifications = plainToClass(Notification, response.result)
        this.pagination.totalCount = response.pageInfo.total_count
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    pageChange (num) {
      this.pagination.page = num
      this.fetchData()
    },
    show (notification) {
      const action = this.actions[notification.type_key]
      if (action) action(notification, this.$route.params.status === 'unread')
    },
    moveTo (status) {
      return {
        name: 'notification-index',
        params: { status: status }
      }
    },
  },
}
